import { useEffect, useState } from "react";
import TrainingAccordion from "./TrainingItem";

export default function TrainingList({ onChange, trainingsData }) {
  const [trainings, setTrainings] = useState([trainingsData]);

  useEffect(() => {
    setTrainings(trainingsData);
  }, [trainingsData]);

  const handleAddTraining = () => {
    setTrainings((prev) => [
      ...prev,
      {
        id: Date.now(),
        title: `Training ${prev.length + 1}`,
        validFrom: "",
        expiry: "",
        comment: "",
        attachment: null,
      },
    ]);
  };

  const handleUpdateTraining = (id, updatedData) => {
    setTrainings((prev) => {
      const updated = prev.map((t) =>
        t.id === id ? { ...t, ...updatedData } : t
      );
      onChange(updated);
      return updated;
    });
  };

  const handleDeleteTraining = (id) => {
    setTrainings((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <div className="space-y-4">
      {trainings.map((training) => (
        <TrainingAccordion
          key={training.id}
          initialTitle={training.title}
          initialValidFrom={training.validFrom}
          initialExpiry={training.expiry}
          initialComment={training.comment}
          initialAttachment={training.attachment}
          onUpdate={(updatedData) =>
            handleUpdateTraining(training.id, updatedData)
          }
          onDelete={() => handleDeleteTraining(training.id)}
        />
      ))}

      <button
        onClick={handleAddTraining}
        className="px-4 py-2 bg-gray-600 text-white rounded-md text-sm"
      >
        Add Training
      </button>
    </div>
  );
}
